import React from 'react';
import './Review.css';

const review = (props) => {

    let dateArr = new Date(props.time).toString().split(' ');
    let dateStr = dateArr[1]+' '+dateArr[2]+', '+dateArr[3];
    return (
        <div className={'bmw-Review'}>
            <div style={{color:'#5e5e5e', fontWeight:'bold', margin:'3px', fontSize:'1.2em'}}>{props.name}</div>
            <div style={{color:'#5e5e5e', fontSize:'1em'}}>{dateStr}</div>
            <div>
                <i className={'star'}></i>
                <i className={'star'}></i>
                <i className={'star'}></i>
                <i className={'star'}></i>
                <i className={'star'}></i>
            </div>
            <p>{props.body}</p>
        </div>
    )
}

export default review;